/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { RequestCommand } = require('./RequestCommands');

class EmptyCommand extends RequestCommand {
	constructor(sheet) {
		super(sheet);
		this.isNoOp = true;
		this.isVolatile = true;
	}
	getExecuteRequest() {
		return undefined;
	}
	getRedoRequest() {
		return undefined;
	}
	getUndoRequest() {
		return undefined;
	}
}

module.exports = EmptyCommand;
